<app-project-location-map readOnly="true" style="max-height: 75vh"></app-project-location-map>
<app-graphical-view-list [projectId]="idProject" [isChipView]="true"></app-graphical-view-list>

